import Empty from 'constants/empty';
import { createSelector } from 'reselect';
import { testTargetOffersSelector } from 'selectors/testTarget/offers/testTargetOffersSelector';

const collapseHighlightsSectionPdpSelector = createSelector(testTargetOffersSelector, offers => offers.collapseHighlightsSectionPdp || Empty.Object);

export { collapseHighlightsSectionPdpSelector };
